import { useCallback, useEffect, useState } from 'react';
import { inventarioService, modificadoresService } from '../../services/api';
import { useToast } from '../../components/ui/Toast';
import Dialogo from '../../components/ui/Dialogo';
import { btnPrimario, btnSecundario, chip, segmentos, segmento } from '../../components/ui/estilos';
import { entrada, tarjetaLista } from '../agenda/campos';

const n = (v: any) => parseFloat(v || 0) || 0;
const TIPOS: [string, string][] = [['unico', 'Una opción'], ['multiple', 'Varias opciones']];

export default function Modificadores() {
  const [toast, say] = useToast();
  const [grupos, setGrupos] = useState<any[]>([]);
  const [insumos, setInsumos] = useState<any[]>([]);
  const [selId, setSelId] = useState<string | null>(null);
  const [nuevo, setNuevo] = useState(false);

  const cargar = useCallback(() => modificadoresService.getAll().then(r => setGrupos(r.data)).catch(() => say('No se pudieron cargar los modificadores.')), [say]);
  useEffect(() => { cargar(); inventarioService.getInsumos().then(r => setInsumos(r.data)).catch(() => {}); }, [cargar]);
  const g = grupos.find(x => x.id === selId) || null;

  // Cambios del grupo se guardan al momento: son pocos campos y sin validación cruzada.
  const guardarGrupo = (datos: object) => g && modificadoresService.actualizarGrupo(g.id, { nombre: g.nombre, tipo: g.tipo, obligatorio: g.obligatorio, ...datos })
    .then(cargar).catch((e: any) => say(e.response?.data?.error || 'No se pudo guardar el grupo.'));

  const eliminar = async () => {
    if (!g || !window.confirm(`¿Eliminar el grupo "${g.nombre}"? Se quita de ${g.productos?.length || 0} productos.`)) return;
    try { await modificadoresService.eliminarGrupo(g.id); say(`${g.nombre} eliminado.`); setSelId(null); cargar(); }
    catch (e: any) { say(e.response?.data?.error || 'No se pudo eliminar.'); }
  };

  return (
    <div className="paneles" style={{ margin: '-22px -24px', height: 'calc(100% + 44px)', minHeight: 480, display: 'grid', gridTemplateColumns: 'clamp(280px,36%,420px) minmax(320px,1fr)' }}>
      <aside aria-label="Grupos" style={{ borderRight: '1px solid var(--line)', background: 'var(--surface)', display: 'flex', flexDirection: 'column', minHeight: 0 }}>
        <div style={{ padding: 16, flex: 'none' }}>
          <button onClick={() => setNuevo(true)} style={{ ...btnPrimario, width: '100%', height: 48, fontSize: 15 }}>+ Grupo</button>
        </div>
        <div style={{ flex: 1, minHeight: 0, overflowY: 'auto', padding: '0 12px 16px', display: 'flex', flexDirection: 'column', gap: 8 }}>
          {!grupos.length && <div style={{ padding: 24, textAlign: 'center', color: 'var(--muted)' }}>Sin grupos todavía.</div>}
          {grupos.map(x => (
            <button key={x.id} onClick={() => setSelId(x.id)} aria-pressed={selId === x.id} style={tarjetaLista(selId === x.id)}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', gap: 8 }}>
                <span style={{ fontSize: 16, fontWeight: 700 }}>{x.nombre}</span>
                <span style={{ ...chip('var(--well)', 'var(--muted)'), fontSize: 12, padding: '2px 8px' }}>{x.tipo === 'unico' ? 'Una opción' : 'Varias'}{x.obligatorio ? ' · oblig.' : ''}</span>
              </div>
              <span style={{ fontSize: 13, color: 'var(--muted)' }}>{x.opciones?.length ? x.opciones.map((o: any) => o.nombre).join(', ') : 'Sin opciones'}</span>
            </button>
          ))}
        </div>
      </aside>

      <main style={{ minHeight: 0, overflowY: 'auto', padding: '22px 26px', display: 'flex', flexDirection: 'column', gap: 16 }}>
        {!g ? <div style={{ flex: 1, display: 'grid', placeItems: 'center', color: 'var(--muted)', fontSize: 16 }}>Elige un grupo para editarlo.</div> : <>
          <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            <input key={g.id + g.nombre} defaultValue={g.nombre} aria-label="Nombre del grupo" maxLength={80}
              onBlur={e => e.target.value.trim() && e.target.value.trim() !== g.nombre && guardarGrupo({ nombre: e.target.value.trim() })}
              style={{ fontSize: 24, fontWeight: 700, border: 'none', background: 'transparent', color: 'var(--ink)', padding: '2px 4px', flex: 1, minWidth: 0 }} />
            <button onClick={eliminar} style={{ background: 'none', border: 'none', color: 'var(--danger)', fontSize: 14, fontWeight: 700, cursor: 'pointer' }}>Eliminar grupo</button>
          </div>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: 14, alignItems: 'center' }}>
            <div role="radiogroup" aria-label="Tipo" style={segmentos}>
              {TIPOS.map(([k, l]) => <button key={k} role="radio" aria-checked={g.tipo === k} onClick={() => g.tipo !== k && guardarGrupo({ tipo: k })} style={{ ...segmento(g.tipo === k), height: 44, fontSize: 15 }}>{l}</button>)}
            </div>
            <label style={{ display: 'flex', alignItems: 'center', gap: 10, fontSize: 16, fontWeight: 700, cursor: 'pointer' }}>
              <input type="checkbox" checked={!!g.obligatorio} onChange={e => guardarGrupo({ obligatorio: e.target.checked })} style={{ width: 22, height: 22, accentColor: 'var(--brand-texto)' }} />
              Obligatorio elegir
            </label>
          </div>

          <section style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
            <div style={{ display: 'grid', gridTemplateColumns: 'minmax(0,1fr) 120px 44px', gap: 8, padding: '0 4px', fontSize: 12, fontWeight: 700, color: 'var(--muted)' }}>
              <span>OPCIÓN</span><span style={{ textAlign: 'right' }}>PRECIO EXTRA</span><span />
            </div>
            {(g.opciones || []).map((o: any) => <Opcion key={o.id} o={o} insumos={insumos} say={say} onCambio={cargar} />)}
            <button onClick={() => modificadoresService.crearOpcion(g.id, { nombre: 'Nueva opción', precio_extra: 0, orden: g.opciones?.length || 0 }).then(cargar).catch(() => say('No se pudo agregar.'))}
              style={{ ...btnSecundario, alignSelf: 'flex-start', borderStyle: 'dashed' }}>+ Opción</button>
          </section>

          <section style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
            <h2 style={{ margin: 0, fontSize: 15, fontWeight: 700, color: 'var(--muted)' }}>Se usa en</h2>
            {!g.productos?.length ? <div style={{ color: 'var(--muted)' }}>Ningún producto todavía. Asígnalo desde Menú › Productos.</div> : (
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>{g.productos.map((p: string) => <span key={p} style={chip('var(--well)', 'var(--ink)')}>{p}</span>)}</div>
            )}
          </section>
        </>}
      </main>

      {nuevo && <NuevoGrupo say={say} onCerrar={() => setNuevo(false)} onCreado={id => { setNuevo(false); setSelId(id); cargar(); }} />}
      {toast}
    </div>
  );
}

// Una opción editable en línea; el vínculo con inventario va plegado (se usa poco).
function Opcion({ o, insumos, say, onCambio }: { o: any; insumos: any[]; say: (m: string) => void; onCambio: () => void }) {
  const [inv, setInv] = useState(!!o.insumo_id);
  const guardar = (datos: object) => modificadoresService.actualizarOpcion(o.id, {
    nombre: o.nombre, precio_extra: n(o.precio_extra), insumo_id: o.insumo_id || null, operacion: o.operacion || null,
    cantidad_insumo: o.cantidad_insumo ? n(o.cantidad_insumo) : null, activo: o.activo, orden: o.orden, ...datos,
  }).then(onCambio).catch((e: any) => say(e.response?.data?.error || 'No se pudo guardar la opción.'));

  return (
    <div style={{ border: '1px solid var(--line)', borderRadius: 10, padding: 8, display: 'flex', flexDirection: 'column', gap: 8 }}>
      <div style={{ display: 'grid', gridTemplateColumns: 'minmax(0,1fr) 120px 44px', gap: 8, alignItems: 'center' }}>
        <input defaultValue={o.nombre} aria-label="Opción" maxLength={100} onBlur={e => e.target.value.trim() && e.target.value.trim() !== o.nombre && guardar({ nombre: e.target.value.trim() })} style={{ ...entrada, height: 44 }} />
        <input type="number" min="0" inputMode="decimal" defaultValue={n(o.precio_extra) || ''} placeholder="0" aria-label={`Precio extra de ${o.nombre}`}
          onBlur={e => n(e.target.value) !== n(o.precio_extra) && guardar({ precio_extra: n(e.target.value) })} style={{ ...entrada, height: 44, textAlign: 'right' }} />
        <button onClick={() => window.confirm(`¿Quitar "${o.nombre}"?`) && modificadoresService.eliminarOpcion(o.id).then(onCambio).catch(() => say('No se pudo quitar.'))}
          aria-label={`Quitar ${o.nombre}`} style={{ ...btnSecundario, width: 44, height: 44, padding: 0 }}>✕</button>
      </div>
      <button onClick={() => setInv(v => !v)} aria-expanded={inv} style={{ alignSelf: 'flex-start', background: 'none', border: 'none', padding: '0 4px', fontSize: 13, fontWeight: 700, color: 'var(--muted)', cursor: 'pointer' }}>
        {o.insumo_id ? `Inventario: ${o.operacion === 'quitar' ? 'no descuenta' : 'descuenta'} ${o.insumo_nombre}${o.operacion === 'agregar' ? ` × ${n(o.cantidad_insumo)}` : ''}` : 'Vincular con inventario'} {inv ? '▴' : '▾'}
      </button>
      {inv && (
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
          <select defaultValue={o.insumo_id || ''} aria-label="Insumo" style={{ ...entrada, height: 44, flex: '1 1 180px', width: 'auto' }}
            onChange={e => guardar(e.target.value ? { insumo_id: e.target.value, operacion: o.operacion || 'quitar' } : { insumo_id: null, operacion: null, cantidad_insumo: null })}>
            <option value="">Sin insumo</option>
            {insumos.map(i => <option key={i.id} value={i.id}>{i.nombre} ({i.unidad})</option>)}
          </select>
          {o.insumo_id && <>
            <select defaultValue={o.operacion || 'quitar'} aria-label="Qué hace" style={{ ...entrada, height: 44, flex: '1 1 200px', width: 'auto' }}
              onChange={e => guardar({ operacion: e.target.value, cantidad_insumo: e.target.value === 'agregar' ? (n(o.cantidad_insumo) || 1) : null })}>
              <option value="quitar">No descontar de la receta (ej. "sin cebolla")</option>
              <option value="agregar">Descontar extra (ej. "doble queso")</option>
            </select>
            {o.operacion === 'agregar' && <input type="number" min="0" step="any" defaultValue={o.cantidad_insumo || ''} aria-label="Cantidad" placeholder="Cant."
              onBlur={e => n(e.target.value) > 0 && n(e.target.value) !== n(o.cantidad_insumo) && guardar({ cantidad_insumo: n(e.target.value) })} style={{ ...entrada, height: 44, width: 100 }} />}
          </>}
        </div>
      )}
    </div>
  );
}

function NuevoGrupo({ say, onCerrar, onCreado }: { say: (m: string) => void; onCerrar: () => void; onCreado: (id: string) => void }) {
  const [nombre, setNombre] = useState('');
  const [error, setError] = useState('');
  const crear = async () => {
    if (!nombre.trim()) { setError('Escribe el nombre del grupo (ej. Término de cocción).'); return; }
    try { const { data } = await modificadoresService.crearGrupo({ nombre: nombre.trim(), tipo: 'unico', obligatorio: false }); say(`${nombre.trim()} creado.`); onCreado(data.id); }
    catch (e: any) { setError(e.response?.data?.error || 'No se pudo crear el grupo.'); }
  };
  return (
    <Dialogo titulo="Nuevo grupo de modificadores" onCerrar={onCerrar} ancho={420}>
      <input autoFocus placeholder="Nombre (ej. Término de cocción)" value={nombre} onChange={e => setNombre(e.target.value)} onKeyDown={e => e.key === 'Enter' && crear()} maxLength={80} style={entrada} aria-label="Nombre del grupo" />
      {error && <div role="alert" style={{ color: 'var(--danger)', fontWeight: 700 }}>{error}</div>}
      <div style={{ display: 'flex', gap: 10 }}>
        <button onClick={onCerrar} style={{ ...btnSecundario, flex: 1, height: 52 }}>Cancelar</button>
        <button onClick={crear} style={{ ...btnPrimario, flex: 2, height: 52, fontSize: 16 }}>Crear grupo</button>
      </div>
    </Dialogo>
  );
}
